"use client";

import { useState } from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { FormProvider } from "@/integrations/forms/FormProvider";
import { Phone, X } from "lucide-react";
export default function Hero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    nombreApellidos: "",
    empresaEdificio: "",
    telefono: "",
    ciudad: "",
    tipoInmueble: "",
    mensaje: ""
  });
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  const handleSubmit = () => {
    setIsSubmitted(true);
    setTimeout(() => {
      setIsSubmitted(false);
      setIsModalOpen(false);
      setFormData({
        nombreApellidos: "",
        empresaEdificio: "",
        telefono: "",
        ciudad: "",
        tipoInmueble: "",
        mensaje: ""
      });
    }, 3000);
  };
  return <>
      <section ref={ref} className="relative w-full overflow-hidden">
        <div className="grid h-screen lg:grid-cols-2 gap-0">
          {}
          <div className={`flex items-center justify-center bg-background px-12 transition-all duration-[250ms] ease-[cubic-bezier(0.25,0.46,0.45,0.94)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
            <div className="max-w-xl space-y-6 text-center lg:text-left">
              <h1 className="font-display text-4xl font-bold leading-tight text-foreground sm:text-5xl lg:text-6xl">
                Limpieza de fachadas, vidrios y paneles solares
              </h1>
              <p className="text-xl leading-relaxed text-muted-foreground sm:text-2xl">
                Soluciones de limpieza en altura con drones en Colombia. Más seguro, más rápido y más eficiente que los métodos tradicionales.
              </p>
              <div className="flex justify-center lg:justify-start">
                
              </div>
            </div>
          </div>

          {}
          <div className="relative hidden lg:block h-full">
            <div className="absolute inset-0 bg-cover bg-[center_20%] bg-no-repeat bg-[url(https://aerolimpio.com/wp-content/uploads/2025/12/cropped-Gemini_Generated_Image_5cg42m5cg42m5cg4.png)] h-full w-full">
              {}
            </div>
          </div>

          {}
          <div className="lg:hidden absolute bottom-8 left-0 right-0 flex justify-center z-10">
            <Button size="lg" onClick={() => setIsModalOpen(true)} className="btn-primary h-16 px-10 text-lg font-semibold shadow-strong hover:shadow-strong hover:-translate-y-1 transition-all duration-[250ms] ease-[cubic-bezier(0.34,1.56,0.64,1)]">
              Solicitar visita y presupuesto
            </Button>
          </div>
        </div>

        {}
        
      </section>

      {}
      {isModalOpen && <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4 animate-fade-in-up" onClick={() => setIsModalOpen(false)}>
          <div className="bg-white rounded-lg shadow-strong max-w-2xl w-full max-h-[90vh] overflow-y-auto" onClick={e => e.stopPropagation()}>
            {}
            <div className="sticky top-0 bg-white border-b border-border px-6 py-4 flex items-center justify-between rounded-t-lg">
              <h2 className="font-display text-2xl font-bold text-secondary">
                Solicitar visita técnica
              </h2>
              <Button variant="ghost" size="icon" onClick={() => setIsModalOpen(false)} className="hover:bg-muted-light">
                <X className="size-5" />
              </Button>
            </div>

            {}
            <div className="px-6 py-8">
              {!isSubmitted ? <>
                  <p className="text-base text-muted-foreground mb-6 leading-relaxed">
                    Cuéntanos brevemente tu proyecto y te contactamos para coordinar una visita técnica.
                  </p>

                  <FormProvider onSubmit={handleSubmit}>
                    <div className="space-y-4">
                      {}
                      <div className="space-y-2">
                        <label htmlFor="nombreApellidos" className="block text-sm font-semibold text-secondary">
                          Nombre y apellidos <span className="text-primary">*</span>
                        </label>
                        <input type="text" id="nombreApellidos" name="nombreApellidos" required value={formData.nombreApellidos} onChange={handleInputChange} className="w-full h-12 px-4 bg-secondary-100 border border-border rounded-lg text-secondary placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary/60 focus:border-primary transition-all" placeholder="Ej: Juan Pérez" />
                      </div>

                      {}
                      <div className="space-y-2">
                        <label htmlFor="empresaEdificio" className="block text-sm font-semibold text-secondary">
                          Empresa / Edificio <span className="text-primary">*</span>
                        </label>
                        <input type="text" id="empresaEdificio" name="empresaEdificio" required value={formData.empresaEdificio} onChange={handleInputChange} className="w-full h-12 px-4 bg-secondary-100 border border-border rounded-lg text-secondary placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary/60 focus:border-primary transition-all" placeholder="Ej: Torre Empresarial Centro" />
                      </div>

                      {}
                      <div className="space-y-2">
                        <label htmlFor="telefono" className="block text-sm font-semibold text-secondary">
                          Teléfono (WhatsApp) <span className="text-primary">*</span>
                        </label>
                        <input type="tel" id="telefono" name="telefono" required value={formData.telefono} onChange={handleInputChange} className="w-full h-12 px-4 bg-secondary-100 border border-border rounded-lg text-secondary placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary/60 focus:border-primary transition-all" placeholder="Ej: +57 300 123 4567" />
                      </div>

                      {}
                      <div className="space-y-2">
                        <label htmlFor="ciudad" className="block text-sm font-semibold text-secondary">
                          Ciudad <span className="text-primary">*</span>
                        </label>
                        <input type="text" id="ciudad" name="ciudad" required value={formData.ciudad} onChange={handleInputChange} className="w-full h-12 px-4 bg-secondary-100 border border-border rounded-lg text-secondary placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary/60 focus:border-primary transition-all" placeholder="Ej: Bogotá" />
                      </div>

                      {}
                      <div className="space-y-2">
                        <label htmlFor="tipoInmueble" className="block text-sm font-semibold text-secondary">
                          Tipo de inmueble
                        </label>
                        <select id="tipoInmueble" name="tipoInmueble" value={formData.tipoInmueble} onChange={handleInputChange} className="w-full h-12 px-4 bg-secondary-100 border border-border rounded-lg text-secondary placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary/60 focus:border-primary transition-all">
                          <option value="">Seleccionar...</option>
                          <option value="residencial">Edificio residencial</option>
                          <option value="corporativo">Edificio corporativo / oficinas</option>
                          <option value="industrial">Industria / planta</option>
                          <option value="solar">Paneles solares</option>
                        </select>
                      </div>

                      {}
                      <div className="space-y-2">
                        <label htmlFor="mensaje" className="block text-sm font-semibold text-secondary">
                          Mensaje
                        </label>
                        <textarea id="mensaje" name="mensaje" rows={4} value={formData.mensaje} onChange={handleInputChange} className="w-full px-4 py-3 bg-secondary-100 border border-border rounded-lg text-secondary placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary/60 focus:border-primary transition-all resize-none" placeholder="Cuéntanos más sobre tu proyecto..." />
                      </div>

                      {}
                      <div className="pt-4">
                        <Button type="submit" size="lg" className="w-full btn-primary h-14 text-base font-semibold shadow-strong hover:shadow-strong hover:-translate-y-1 transition-all duration-[250ms] ease-[cubic-bezier(0.34,1.56,0.64,1)]">
                          Enviar solicitud
                        </Button>
                      </div>
                    </div>
                  </FormProvider>
                </> : <div className="text-center py-12 animate-fade-in-up">
                  <div className="inline-flex items-center justify-center size-16 rounded-full bg-primary/20 mb-4">
                    <svg className="size-8 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <h3 className="font-display text-xl font-bold text-secondary mb-2">
                    ¡Solicitud enviada!
                  </h3>
                  <p className="text-base text-muted-foreground max-w-md mx-auto leading-relaxed">
                    Gracias por tu solicitud. Nuestro equipo se pondrá en contacto contigo para coordinar la visita técnica.
                  </p>
                </div>}
            </div>
          </div>
        </div>}

      {}
      <Link to="https://wa.me/573162738270" newTab className="fixed bottom-6 right-6 z-40 group">
        <Button size="lg" className="btn-primary h-14 px-6 gap-2 shadow-strong hover:shadow-strong hover:-translate-y-1 transition-all duration-[250ms] ease-[cubic-bezier(0.34,1.56,0.64,1)]">
          <Phone className="size-5" />
          <span className="hidden sm:inline font-semibold">Hablar por WhatsApp</span>
          <span className="sm:hidden font-semibold">WhatsApp</span>
        </Button>
      </Link>
    </>;
}